import type { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import { AppState } from './store';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import {
  postCancellationForSponsorshipsBySponsorshipIdResponse,
  putInvitationResponseForSponsorshipsBySponsorshipIdResponse,
} from './sponsorshipModel';
import { fetchSessionForAuthRequest } from './sessionModel';

/**
 * Middleware to invalidate & refetch client data when sponsorship data is updated
 */
function sponsorshipMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  _getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (
    action.type ===
      postCancellationForSponsorshipsBySponsorshipIdResponse.type ||
    action.type ===
      putInvitationResponseForSponsorshipsBySponsorshipIdResponse.type
  ) {
    dispatch(fetchSessionForAuthRequest());
  }
}

export const sponsorshipMiddleware = createSimpleMiddleware(
  sponsorshipMiddlewareImpl,
);
